<template>
    <div class="container">
        <div>
            <h3>Register</h3>
        </div>

        <template v-if="!register.info">

            <feedback :error="register.error"/>

            <div class="form-group">
                <label>First Name</label>
                <input class="form-control" type="text"
                       @input="onChange"
                       v-bind:value="register.firstName"
                       v-bind:class="{'is-invalid': register.fieldErrors.firstName}"
                       name="firstName">
                <div class="invalid-feedback" v-if="register.fieldErrors.firstName">
                    {{register.fieldErrors.firstName}}
                </div>
            </div>
            <div class="form-group">
                <label>Last Name</label>
                <input class="form-control"
                       name="lastName"
                       @input="onChange"
                       v-bind:value="register.lastName"
                       v-bind:class="{'is-invalid': register.fieldErrors.lastName}"
                       type="text">
                <div class="invalid-feedback" v-if="register.fieldErrors.lastName">
                    {{register.fieldErrors.lastName}}
                </div>
            </div>
            <div class="form-group">
                <label>Email</label>
                <input class="form-control"
                       @input="onChange"
                       v-bind:value="register.email"
                       v-bind:class="{'is-invalid': register.fieldErrors.email}"
                       name="email"
                       type="email">
                <div class="invalid-feedback" v-if="register.fieldErrors.email">
                    {{register.fieldErrors.email}}
                </div>
            </div>
            <div class="form-group">
                <label>Password</label>
                <input class="form-control"
                       @input="onChange"
                       v-bind:value="register.password"
                       v-bind:class="{'is-invalid': register.fieldErrors.password}"
                       name="password"
                       type="password">
                <div class="invalid-feedback" v-if="register.fieldErrors.password">
                    {{register.fieldErrors.password}}
                </div>
            </div>
            <div class="form-group">
                <button type="button" class="btn btn-primary mr-2"
                        v-if="!register.submitting"
                        v-on:click="submit">Submit</button>
            </div>

            <hr/>

            <div class="form-group">
                <a href="/api/users/google-login" ><font-awesome-icon :icon="['fab', 'google']" class="red"></font-awesome-icon> <span class="ml-2">Register using google account</span></a>
            </div>
        </template>
        <template v-if="register.info">
            <div class="form-group">
                <feedback :info="register.info" />
                <router-link to="/login">Click to log in</router-link>
            </div>
        </template>

    </div>
</template>

<script>
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import {mapState, mapActions} from "vuex";
    import {REGISTER, REGISTER_ON_CHANGE, REGISTER_ON_VALIDATE, REGISTER_RESET} from "../../store/register";
    import Feedback from "../commons/feedback";

    export default {
        name: "register",
        components: {
            Feedback,
            FontAwesomeIcon
        },
        computed: mapState({
            register: state => state.register,
        }),
        methods: {
            ...mapActions({
                submitRegistration: REGISTER,
                onRegChange: REGISTER_ON_CHANGE,
                validate: REGISTER_ON_VALIDATE,
                reset: REGISTER_RESET,
            }),
            onChange(event) {
                this.onRegChange({name: event.target.name, value: event.target.value});
            },
            submit() {
                this.validate();
                if(this.register.error){
                    return;
                }

                this.submitRegistration(() => {
                    //dont do anything now
                });
            }
        },
        mounted() {
            this.reset();
        }
    }
</script>

<style scoped>

</style>
